module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success display-flex justify-center align-center gap-4 pa-4"
  }, [_c('div', {
    staticClass: "text-white font-32 font-weight-500"
  }, [_vm._v("Success!")]), _vm._v(" "), _c('div', {
    staticClass: "text-white font-22 font-weight-500"
  }, [_vm._v("\n    Welcome to the community\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-white font-24 font-weight-500"
  }, [_vm._v("Loud Pack")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../assets/mobile/success.gif"),
      "width": 400
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-go mx-0 mt-4 full-width",
    on: {
      "click": function($event) {
        _vm.$router.push('/communitym')
      }
    }
  }, [_vm._v("\n    Go to community\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1527ea16","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/components/plan-detail/success.vue
// module id = 1621
// module chunks = 180